// extracted by mini-css-extract-plugin
module.exports = {"menuListItemBlock":"MenuListItemBlock_menuListItemBlock__2pkiC","blockTitle":"MenuListItemBlock_blockTitle__3k7O-","foodItemCardList":"MenuListItemBlock_foodItemCardList__3Hv8n"};